<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white font-weight-bold d-flex align-items-center">
      {{ this.$string.sidebar.menu_7.sub_menu.menu_1 }}
       <template v-if="role_status && role_status.status_export_excel">
        <CButton color="info" class="btn-md ml-auto mr-2">Ekspor Excel</CButton>
      </template>
      <template v-else> 
        <CButton color="secondary" class="btn-md ml-auto mr-2" disabled>Ekspor Excel</CButton>
      </template>
      <template v-if="role_status && role_status.status_create">
      <CButton
        color="success"
        style="float:right;margin-right:10px"
        class="btn-md"
        @click="myModal = true"
      >Tambah</CButton>
      </template>
      <template v-else> 
      <CButton
        color="secondary"
        style="float:right;margin-right:10px"
        class="btn-md"
        disabled
      >Tambah</CButton>
      </template>     
    </CCardHeader>
    <!-- Data Broadcast -->
    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol> 
      </CRow>
      <CRow>
        <CCol sm="12" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            
            <template #subject="{item}">
              <td class="py-2">{{item.subject ? item.subject : "-"}}</td>
            </template>
            
            <template #text="{item}">
              <td class="py-2">
                {{ item.text.length > 100 ? item.text.substring(0, 100) + '...' : item.text }}
              </td>
            </template>

            <template #created_at="{item}">
              <td class="py-2">
                {{ item.created_at | moment }}
              </td>
            </template>

            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                  <template v-if="role_status && role_status.status_read">
                    <CButton color="success" class="btn-sm text-white mr-2" square @click="showdetailEmail(item)">
                      <font-awesome-icon icon="eye" />
                    </CButton>
                  </template>
                  <template v-else> 
                    <CButton color="secondary" class="btn-sm text-white mr-2" square disabled>
                      <font-awesome-icon icon="eye" />
                    </CButton>
                  </template>
                  <template v-if="role_status && role_status.status_delete">
                  <CButton color="danger" class="btn-sm text-white" square @click="deleteData(item, index)">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                  </template>
                  <template v-else> 
                  <CButton color="secondary" class="btn-sm text-white" square disabled>
                    <font-awesome-icon icon="trash" />
                  </CButton>
                  </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />          
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Kirim Email"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Kirim Email</h6>          
        </template>
        <CForm>
          <CRow>
            <CCol sm="12">
              <div class="form-group">
                <label for="tujuan-email" class="font-weight-bold">Tujuan</label>                                
                <div>                  
                  <multiselect 
                    v-model="formData.tujuanEmail" 
                    placeholder="Pilih tujuan E-Mail" 
                    label="nama_lengkap" 
                    track-by="email" 
                    :options="receiverOptions" 
                    :multiple="true"
                    @remove="removeSingelReceiver"
                    :class="{
                      'has-error': $v.formData.tujuanEmail.$error
                    }"
                  >                    
                    <template v-slot:noResult>
                      User tidak ditemukan
                    </template>
                  </multiselect>           
                </div>            
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" :value="selectAllReceiver" v-model="selectAllReceiver" id="defaultCheck1">
                  <label class="form-check-label" for="selectAllReceiver">
                    Pilih semua
                  </label>
                </div>   
              </div>
            </CCol>
            <CCol sm="12">
              <div class="form-group">
                <label for="cc-email" class="font-weight-bold">Pilih CC</label>                                
                <div>                  
                  <multiselect 
                    v-model="formData.cc" 
                    placeholder="Pilih CC E-Mail" 
                    label="nama_lengkap" 
                    track-by="email" 
                    :options="ccOptions" 
                    :multiple="true"
                    @remove="removeSingleCC"
                  >                    
                    <template v-slot:noResult>
                      User tidak ditemukan
                    </template>
                  </multiselect> 
                </div>            
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" :value="selectAllcc" v-model="selectAllcc" id="defaultCheck1">
                  <label class="form-check-label" for="selectAllcc">
                    Pilih semua
                  </label>
                </div>
              </div>
            </CCol>
            <CCol sm="12">
              <div class="form-group">
                <label for="cc-email" class="font-weight-bold">Pilih BCC</label>                                
                <div>                  
                  <multiselect 
                    v-model="formData.bcc" 
                    placeholder="Pilih BCC E-Mail" 
                    label="nama_lengkap" 
                    track-by="email" 
                    :options="bccOptions" 
                    :multiple="true"
                    @remove="removeSingleBCC"
                  >                     
                    <template v-slot:noResult>
                      User tidak ditemukan
                    </template>
                  </multiselect> 
                </div>            
                <div class="form-check mt-1">
                  <input class="form-check-input" type="checkbox" :value="selectAllBcc" v-model="selectAllBcc" id="defaultCheck1">
                  <label class="form-check-label" for="selectAllBcc">
                    Pilih semua
                  </label>
                </div>
              </div>
            </CCol>
            <CCol sm="12">
              <label for="nama_divisi" class="font-weight-bold">Subjek</label>
              <input
                type="text"
                class="form-control"
                :class="{
                  'border-danger': $v.formData.subject.$error,                   
                }"
                id="subject"
                placeholder="Masukkan Subjek"                  
                v-model="formData.subject"
                aria-required="true"                   
              />            
            </CCol>
            <CCol sm="12">
              <div class="form-group">
                <label for="body" class="font-weight-bold">Pesan</label>
                <textarea 
                  class="form-control" 
                  id="body" 
                  rows="3"
                  :class="{
                    'border-danger': $v.formData.text.$error
                  }"
                  v-model="formData.text"
                  placeholder="Masukkan Isi Pesan"
                ></textarea>
              </div>                            
            </CCol>
            <CCol sm="12 mb-5">
              <label for="uid-zwqayuopq3" class="font-weight-bold">File (Opsional)</label>
              <br />
              <ul class="list-group mb-2">
                <li 
                  v-for="(file, index) in formData.file"
                  class="list-group-item py-1 d-flex justify-content-between align-items-center"
                  :key="index"
                >
                  {{ file.name }}
                  <button class="btn btn-sm e-transparent" @click="handleRemoveFile(file, index)">
                    <font-awesome-icon icon="times" class="text-danger" />
                  </button>
                </li>   
              </ul>
              <div class="custom-file text-truncate">
                <input type="file" class="custom-file-input" id="customFile" multiple @change="handleFileUpload">
                <label class="custom-file-label" for="customFile" data-browse="Pilih File">Attachments</label>
                <small class="text-danger">(*File harus bertipe PDF, PNG max. 10MB)</small>
              </div>              
            </CCol>
          </CRow>
        </CForm>        
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton type="submit" color="success" @click="sendEmailBroadcast">Kirim</CButton>
        </template>
      </CModal>
      <!-- End Modal -->

      <!-- Modal Detail -->
      <CModal
        title="Detail Email"        
        :show.sync="detailModal"                 
        :no-close-on-backdrop="true"
        :centered="true"        
      >
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Detail Email</h6>          
        </template>
        <div class="table-responsive">
          <table class="table table-bordered">
            <tbody>              
              <tr>
                <th>Subjek</th>
                <th>{{ detailEmail.detailData ? detailEmail.detailData.subject : '' }}</th>
              </tr>
              <tr>
                <th>Isi Pesan</th>
                <th>{{ detailEmail.detailData ? detailEmail.detailData.text : '' }}</th>
              </tr>
              <tr>
                <th>Jumlah Email</th>
                <th>{{ detailEmail.detailData ? detailEmail.detailData.jumlahEmail : '' }}</th>
              </tr>                               
              <tr>
                <th>Jumlah Tujuan</th>
                <th>  
                  {{ detailEmail.emailTo ? detailEmail.emailTo.length : 0 }} 
                  <a                     
                    data-toggle="collapse" 
                    href="#collapseEmailTo" 
                    role="button" 
                    aria-expanded="false" 
                    aria-controls="collapseEmailTo"                    
                  >
                    (Detail)
                  </a>
                </th>                
              </tr>   
              <tr v-if="detailEmail.emailTo">
                <th colspan="2" class="collapse" id="collapseEmailTo" v-if="detailEmail.emailTo">
                  <h4>
                    <span class="badge badge-secondary mr-2" v-for="(item, index) in detailEmail.emailTo" :key="index">
                      {{ item.nama_lengkap }}
                    </span>
                  </h4>                  
                </th>
              </tr>     
              <tr>
                <th>Jumlah CC</th>
                <th>
                  {{ detailEmail.emailCC ? detailEmail.emailCC.length : 0 }}
                  <a 
                    data-toggle="collapse" 
                    href="#collapseEmailCC" 
                    role="button" 
                    aria-expanded="false" 
                    aria-controls="collapseEmailCC"                    
                  >
                    (Detail)
                  </a>
                </th>
              </tr>        
              <tr>
                <th colspan="2" class="collapse" id="collapseEmailCC">
                  <h4>
                    <span class="badge badge-secondary mr-2" v-for="(item, index) in detailEmail.emailCC" :key="index">
                      {{ item.nama_lengkap.split(' ').slice(0, -1).join(' ') }}
                    </span>
                  </h4>
                </th>
              </tr> 
              <tr>
                <th>Jumlah BCC</th>
                <th>
                  {{ detailEmail.emailBCC ? detailEmail.emailBCC.length : 0 }}
                  <a 
                    data-toggle="collapse" 
                    href="#collapseEmailBCC" 
                    role="button" 
                    aria-expanded="false" 
                    aria-controls="collapseEmailBCC"                    
                  >
                    (Detail)
                  </a>
                </th>
              </tr>     
              <tr>
                <th colspan="2" class="collapse" id="collapseEmailBCC">
                  <h4>
                    <span class="badge badge-secondary mr-2" v-for="(item, index) in detailEmail.emailBCC" :key="index">
                      {{ item.nama_lengkap.split(' ').slice(0, -1).join(' ') }}
                    </span>
                  </h4>
                </th>
              </tr>                 
              <tr>
                <th>Tanggal Pengiriman</th>
                <th>{{ detailEmail.detailData ? detailEmail.detailData.created_at : '-' }}</th>
              </tr>                 
            </tbody>
          </table>
        </div>
        <template #footer>
          <CButton @click="detailModal = false" color="danger">Tutup</CButton>          
        </template>
      </CModal>
      <!-- Modal Detail -->
    </CCardBody>
    <!-- End Data Broadcast -->
  </CCard>
</template>
<script>
import EmailBroadcastService from '../../services/broadcast/email-broadcast.service';
import DataKeanggotaanService from '../../services/keanggotaan/data-anggota.service';
import { Pagination } from "../../mixins/Pagination";
import { AlertUtils } from "../../mixins/AlertUtils";
import moment from 'moment';
import { required } from 'vuelidate/lib/validators'

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },  
  {
    key: "subject",
    label: "Subjek",
    sorter: true,
    filter: false
  },
  {
    key: "text",
    label: "Isi Pesan",
    sorter: true,
    filter: false
  },      
  {
    key: "jumlahEmail",
    label: "Jumlah Email",
    sorter: true,
    filter: false
  },      
  {
    key: "created_at",
    label: "Waktu Kirim",
    sorter: true,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Broadcast-Email",
  data() {
    return {
      items: [],
      formData: {
        tujuanEmail: [], // receiver
        cc: [], // cc
        bcc: [], // bcc
        subject: "",
        text: "",
        file: [],
        id_broadcast : "",
      },          
      selectAllReceiver: false,
      selectAllcc: false,
      selectAllBcc: false,
      receiverOptions: [],
      ccOptions: [],
      bccOptions: [],      
      fileName: "Choose File...",
      fields,      
      details: [],
      no: 1,
      pagination: {
        totalPages: 0
      },
      search: "",
      pageSize: "10",            
      currentPage: 0,
      status: false,
      myModal: false,
      detailModal: false,
      detailEmail: {},
      selected: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status : null
    };
  },

  validations: {
    formData: {
      tujuanEmail: { required },
      subject: { required },
      text: { required }
    }
  },

  filters: {
    moment: function (date) {
      return moment(date).format('DD-MM-YYYY');
    }
  },

  mixins: [
    Pagination, AlertUtils
  ],

  watch: {       
    'formData.tujuanEmail': function() {      
      this.ccOptions = this.ccOptions.filter((el) => !this.formData.tujuanEmail.includes(el))
      this.bccOptions = this.bccOptions.filter((el) => !this.formData.tujuanEmail.includes(el))
    },

    'formData.cc': function() {
      this.receiverOptions = this.receiverOptions.filter((el) => !this.formData.cc.includes(el))
      this.bccOptions = this.bccOptions.filter((el) => !this.formData.cc.includes(el))
    },

    'formData.bcc': function() {
      this.receiverOptions = this.receiverOptions.filter((el) => !this.formData.bcc.includes(el))
      this.ccOptions = this.ccOptions.filter((el) => !this.formData.bcc.includes(el))
    },

    selectAllReceiver: function() {    
      if(this.selectAllReceiver) {
        this.formData.tujuanEmail = this.receiverOptions;        
      } else if(this.formData.receiver.tujuanEmail !== this.receiverOptions) {
        this.selectAllReceiver = false
      } else if(!this.selectAllReceiver) {
        this.formData.tujuanEmail = [];
      } else {
        this.formData.tujuanEmail = [];
      }      
    },
    
    selectAllcc: function() {
      if(this.selectAllcc) {
        this.formData.cc = this.ccOptions;
      } else if(this.formData.cc.length !== this.ccOptions) {
        this.selectAllcc = false
      }  else {
        this.formData.cc = [];
      }      
    },

    selectAllBcc: function() {
      if(this.selectAllBcc) {
        this.formData.bcc = this.bccOptions;
      } else if(this.formData.bcc.length !== this.bccOptions) {
        this.selectAllBcc = false
      }  else {
        this.formData.bcc = [];
      }      
    },

    search: function (val) {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {          
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },

    currentPage: function(val) {      
      var page = val - 1;
      this.indexed = page * 10;      
      this.getData(val - 1, this.pageSize, this.search);      
    }
  },  

  mounted() {
    this.getData("0", this.pageSize, "default");
    this.getAllUser();
    this.roleData();
  },  

  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    },
    removeSingelReceiver(item) {            
      this.selectAllReceiver = false        
      this.ccOptions.push(item);
      this.bccOptions.push(item);      
    },    

    removeSingleCC(item) {
      this.selectAllcc = false
      this.receiverOptions.push(item);
      this.bccOptions.push(item);
    },

    removeSingleBCC(item) {      
      this.selectAllBcc = false
      this.receiverOptions.push(item);
      this.ccOptions.push(item);
    },

    handleFileUpload(e) {
      let file = e.target.files;
      if(file.length)        
        this.formData.file.push(e.target.files[0]);                
    },
    handleRemoveFile(file, index) {      
      this.formData.file.splice(index, 1);
    },    
    sendEmailBroadcast() {     
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });              
      this.$v.$touch()
      if (!this.$v.$invalid) {
        EmailBroadcastService.postEmailBroadcast(this.formData) 
          .then(response => {   
            this.alertEmailSuccess();
            this.clearFormData();
            this.myModal = false;
            this.getData("0", this.pageSize, "default");
            setTimeout(() => loader.hide(), 1000);
          })        
          .catch(err => {            
            this.alertEmailFailed();
            setTimeout(() => loader.hide(), 1000);
          })
      } else {
        loader.hide()
      }
    },

    clearFormData() {
      this.formData = {
        tujuanEmail: [], // receiver
        cc: [], // cc
        bcc: [], // bcc
        subject: "",
        text: "",
        file: []
      };
    },

    showdetailEmail(item) {       
      EmailBroadcastService.getDetailEmailBroadcast(item.idBroadcastEmail)
        .then(response => {          
          this.detailEmail = response.data.singleData;                
          // comment console console.log(this.detailEmail)
          this.detailModal = true;
        })
        .catch(error => {
          // comment console console.log(error)
        })      
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      EmailBroadcastService.getEmailBroadcast(currentPage,pageSize,filter)
        .then(response => {
          // comment console console.log(response);
          this.items = response.data.data.content;
          // comment console console.log(this.items)
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          setTimeout(() => loader.hide(), 1000);
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },    

    getAllUser() {    
      DataKeanggotaanService.getAllDataAnggota()
        .then(response => {
          this.receiverOptions = response.data.data;
          this.ccOptions = response.data.data;
          this.bccOptions = response.data.data;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    changePageSize(e) {      
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },

    pageChange() {
      this.getData(currentPage);
    },

     deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          this.formData.id_broadcast = item.idBroadcastEmail
          if (result.value) {
            EmailBroadcastService.deleteBroadcastEmail(this.formData)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, "default");
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>